import _objectSpread from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { filterSystemID } from '@/utils/filters.js';
export default {
  props: {
    date: Object
  },
  filters: {
    filterSystemID: filterSystemID
  },
  data: function data() {
    return {
      ruleForm: {
        dictGroupCode: '',
        dictGroupName: '',
        systemId: ''
      },
      formJson: [{
        prop: 'systemId',
        label: '系统名称',
        disabled: true
      }, {
        prop: 'dictGroupCode',
        label: '字典组键值',
        disabled: false
      }, {
        prop: 'dictGroupName',
        label: '字典组名称'
      }],
      rules: {
        dictGroupCode: [{
          required: true,
          message: '请输入字典组键值',
          trigger: 'blur'
        }, {
          min: 3,
          max: 30,
          message: '长度在 3 到 30 个字符',
          trigger: 'blur'
        }],
        dictGroupName: [{
          required: true,
          message: '请输入字典组名称',
          trigger: 'blur'
        }, {
          min: 1,
          max: 30,
          message: '长度在 1 到 30 个字符',
          trigger: 'blur'
        }],
        systemId: [{
          required: true,
          message: '请输入系统id',
          trigger: 'blur'
        }, {
          min: 1,
          max: 10,
          message: '长度在 1 到 10 个字符',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {},
  methods: {
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.$API.postRequest({
            url: _this.date.subType === 'add' ? '/platform/virtualDict/addVirtualDict' : '/platform/virtualDict/updateVirtualDict',
            data: _objectSpread(_objectSpread({}, _this.ruleForm), {}, {
              id: _this.date.id
            })
          }).then(function (res) {
            if (res.code === '0000000000') {
              _this.$message({
                type: 'success',
                message: _this.date.subType === 'add' ? '新增字典组成功' : '修改字典组成功'
              });
              _this.$emit('close', 'showAddDictGroup');
              _this.$emit('refresh');
            }
          });
        } else {
          return false;
        }
      });
    },
    initForm: function initForm() {
      if (this.date) {
        // eslint-disable-next-line guard-for-in
        for (var key in this.ruleForm) {
          this.ruleForm[key] = this.date[key];
        }
      }
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  created: function created() {
    this.initForm();
  }
};